import React from 'react'

function VerticalCenter({children}) {
    return (
      <div className="mc-app-rely">
        <div className="mc-app-centry">
          {children}
        </div>
      </div>
    )
}

export default VerticalCenter